import { createGlobalStyle } from './styles/styled-components';

const GlobalStyle = createGlobalStyle`
  #kewconf.fontLoaded {
    font-family: 'Source Sans Pro', 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  
  #kewconf button {
    &:focus {
      outline: none !important;
    }
  }
`;

export default GlobalStyle;
